import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../Slider/Slider.css";
import slider2 from "../../img/slider3.jpg";
import slider3 from "../../img/slider2.jpg";
import slider1 from "../../img/1.png";
import logo from "../../img/logo2.png";
import { NavLink } from "react-router-dom";

function Slider() {
  return (
    <>
      <section className="hero-section">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={slider2} alt="Luxury Interior" className="hero-image" />
            <div className="hero-overlay">
              <h1 className="hero-text animate-fade-in-up">
                We prepare Pure Vegetarian Foods only.
              </h1>
              <div className="category-buttons animate-fade-in">
                <NavLink to="/services" className="category-btn">
                  Wedding Ceremony
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Birthday Party
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Religious Events
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  House Party Events
                </NavLink>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <img src={slider1} alt="Commercial Building" className="hero-image" />
            <div className="hero-overlay">
              <h1 className="hero-text animate-fade-in-up">
                Natural ingredients & Spices are used while preparing dishes
              </h1>
              <div className="category-buttons animate-fade-in">
                <NavLink to="/services" className="category-btn">
                  Wedding Ceremony
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Birthday Party
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Religious Events
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  House Party Events
                </NavLink>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <img src={slider3} alt="Residential Home" className="hero-image" />
            <div className="hero-overlay">
              <h1 className="hero-text animate-fade-in-up">
                Our Pricing Structure is best in the market, affordable to everyone
              </h1>
              <div className="category-buttons animate-fade-in">
                <NavLink to="/services" className="category-btn">
                  Wedding Ceremony
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Birthday Party
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  Religious Events
                </NavLink>
                <NavLink to="/services" className="category-btn">
                  House Party Events
                </NavLink>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      {/* Social icons */}
      <div className="social-icons">
        <a
          href="https://www.facebook.com/p/Raju-Caterers-Bangalore-100088382777517/"
          className="social-icon facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://www.instagram.com/rajucaterer1/"
          className="social-icon instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.sulekha.com/raju-caterers-hebbal-bangalore-contact-address"
          className="social-icon sulekha"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} alt="Sulekha" style={{ height: "28px" }} />
        </a>
        <a
          href="https://wa.me/919876543210"
          className="social-icon whatsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    </>
  );
}

export default Slider;
